import {IAction} from '../../interfaces/action';
import {AreaConfigIds} from '../../constants/area-config'; // eslint-disable-line no-unused-vars, max-len
import {
  SELECT_AREA_DENSITY_ID,
  SELECT_AREA_TYPE_ID,
  SELECT_MUNICIPALITY,
  DELETE_AREA_SHAPE
} from '../../constants/actions';

/**
 * Initial state
 */
const initialState = null;

/**
 * Handle the current selected area density
 */
export default function(
  state: AreaConfigIds | null = initialState,
  action: IAction
): AreaConfigIds | null {
  switch (action.type) {
    case SELECT_AREA_DENSITY_ID:
      return action.areaDensityId || state;

    case SELECT_AREA_TYPE_ID:
      return initialState;

    case SELECT_MUNICIPALITY:
      return initialState;

    case DELETE_AREA_SHAPE:
      return initialState;

    default:
      return state;
  }
}
